import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: _ctx.titleDialog,
    modelValue: _ctx.isModalVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.isModalVisible) = $event)),
    class: "bg-light rounded",
    onOpen: _ctx.onOpen,
    onClosed: _ctx.onClosed,
    "close-on-click-modal": false,
    "lock-scroll": "",
    draggable: "",
    "destroy-on-close": "",
    top: "2vh",
    width: "400"
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isModalVisible = false)),
          text: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode("Cancelar")
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          loading: _ctx.loading,
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitForm(_ctx.ruleFormRef)))
        }, {
          default: _withCtx(() => [
            _createTextVNode(" Guardar ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _withDirectives((_openBlock(), _createBlock(_component_el_form, {
            ref: "ruleFormRef",
            model: _ctx.form,
            "status-icon": "",
            rules: _ctx.rules,
            "label-position": "top"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "name_es",
                label: "Nombre en español",
                rules: [{ required: true, message: 'Campo requerido', trigger: ['blur', 'change'] }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name_es,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name_es) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "name_en",
                label: "Nombre en ingles"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.name_en,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.name_en) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                prop: "abrev",
                label: "Abreviatura (max 6 caracteres)",
                rules: [{ required: true, message: 'Campo requerido', trigger: ['blur', 'change'] }]
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.abrev,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.abrev) = $event)),
                    modelModifiers: { trim: true },
                    maxlength: 6,
                    "show-word-limit": "",
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.abrev = _ctx.form.abrev.toUpperCase()))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model", "rules"])), [
            [_directive_loading, _ctx.loading]
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "modelValue", "onOpen", "onClosed"]))
}